import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Card, Radio, RadioGroup } from "@mui/material";
import idioma_lbl from "./index";

export default function EstiloDeVida({ handler_data, handler_obj }) {
  return (
    <React.Fragment>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item>
          <Typography variant="h6" align="center" gutterBottom>
            {idioma_lbl === "en" ? "How does your skin react to 24h of sun without protection?" :
             "¿Cómo reacciona tu piel a 24h de sol sin fotoprotector?"}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} justifyContent="center">
        <Grid item>
          <RadioGroup
            defaultValue=""
            name="fotoprotector"
            onChange={handler_data}
          >
            <FormControlLabel
              value="generalmente"
              control={<Radio />}
              label={idioma_lbl === "en" ? "I usually get burned" : "Generalmente me quemo"}
            />
            <FormControlLabel
              value="raramente"
              control={<Radio />}
              label={idioma_lbl === "en" ? "I rarely get burned" : "Raramente me quemo"}
            />
            <FormControlLabel
              value="nunca"
              control={<Radio />}
              label={idioma_lbl === "en" ? "I never get burned" : "Nunca me quemo"}
            />
            <FormControlLabel
              value="nosabe"
              control={<Radio />}
              label={idioma_lbl === "en" ? "Not sure" : "No estoy seguro/a"}
            />
          </RadioGroup>
        </Grid>
      </Grid>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item>
          <Typography variant="h6" align="center" gutterBottom>
            {idioma_lbl === "en" ? "Is there pollution around your area?" : "¿Hay mucha polución en donde vives?"}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} justifyContent="center">
        <Grid item>
          <RadioGroup defaultValue="" name="polucion" onChange={handler_data}>
            <FormControlLabel value="si" control={<Radio />} label={idioma_lbl === "en" ? "Yes" : "Sí"} />
            <FormControlLabel value="poca" control={<Radio />} label={idioma_lbl === "en" ? "Little" : "Poca"} />
            <FormControlLabel value="no" control={<Radio />} label={idioma_lbl === "en" ? "No" : "No"} />
            <FormControlLabel
              value="nosabe"
              control={<Radio />}
              label={idioma_lbl === "en" ? "Not sure" : "No estoy seguro/a"}
            />
          </RadioGroup>
        </Grid>
      </Grid>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item>
          <Typography variant="h6" align="center" gutterBottom>
            {idioma_lbl === "en" ? "Is your life stressful?" : "¿Tienes una vida estresada?"}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} justifyContent="center">
        <Grid item>
          <RadioGroup defaultValue="" name="stress" onChange={handler_data}>
            <FormControlLabel value="mucho" control={<Radio />} label={idioma_lbl === "en" ? "A lot" : "Mucho"} />
            <FormControlLabel
              value="poco"
              control={<Radio />}
              label={idioma_lbl === "en" ? "A little, but under control" : "Un poco, pero bajo control"}
            />
            <FormControlLabel
              value="no"
              control={<Radio />}
              label={idioma_lbl === "en" ? "Not at all" : "Para nada"}
            />
          </RadioGroup>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
